import { NgModule } from '@angular/core';
import { GlobalSearchComponent } from '../global-search/global-search.component';
import { MaterialModule } from '../core/material.module';
import { WildComponent } from './wild/wild.component';
import { KeysPipe } from './pipe/keys.pipe';
import { RatingComponent } from './rating/rating.component';
import { InsightsComponent } from './insights/insights.component';
import { SharedataService } from './share/service/sharedata.service';
import { ShareApiService } from './share/service/share-api.service';
import { InsightApiService } from './insights/service/insight-api.service';
import { CreateReportComponent } from '../repository/create-report/create-report.component';
import { ImageViewerModule } from '@hallysonh/ngx-imageviewer';
import { ShareComponent } from './share/share.component';
import {VideoModalComponent} from './insights/video-modal/videomodal'
import {VideoModalNewComponent} from './insights/video-modal-new/videomodal'
import { MatDialogModule } from '@angular/material/dialog';
import {VocIntroComponent} from './insights/voc-intro-screen/voc-intro'
import {DeletePopComponent} from './insights/voc-delete/delete-pop'
import { DialogContainerComponent } from '../repository/dialog-container/dialog-container.component';
import { AgGridModule } from 'ag-grid-angular';
import { UploadFileComponent } from '../repository/report-details/upload-file/upload-file/upload-file.component';
import { ExternalFileUploadComponent } from '../repository/report-details/external-file-upload/external-file-upload.component';
import { LoginPopupComponent } from './login-popup/login-popup.component';
import { CopyToClipboardDialogComponent } from './copy-to-clipboard-dialog/copy-to-clipboard-dialog.component';
import { CopyContentDialogComponent } from './copy-content-dialog/copy-content-dialog.component';
import { ExpandMode, NgxTreeSelectModule } from 'src/ngx-tree-select/src';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MainPipe } from './pipe/main.pipe.module';
import { KpiGridRowNameEditComponent } from '../repository/excel-viewer/table-view/kpi-grid-row-name-edit/kpi-grid-row-name-edit.component';
import { SideNavComponent } from './side-nav/side-nav.component';
import { SubSideNavComponent } from './side-nav/sub-side-nav/sub-side-nav.component';
import { SubSideNavChildrenComponent } from './side-nav/sub-side-nav/sub-side-nav-children/sub-side-nav-children.component';
import { RemoveTopcutComponent } from '../repository/excel-viewer/table-view/remove-topcut/remove-topcut.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { RouterModule } from '@angular/router';
import { CommonGridViewComponent } from './common-grid-view/common-grid-view.component';
import { VocIntroPngComponent } from './insights/voc-intro-png/voc-intro-png.component';
import { ViSummaryComponent } from './vi-summary/vi-summary.component';
import { GroupSummaryComponent } from './group-summary/group-summary.component';
import { EditFileComponent } from '../repository/report-details/edit-file/edit-file.component';
import { LogoutConfirmationComponent } from '../logout-confirmation/logout-confirmation.component';
import { AdvancedSearchComponent } from './advanced-search/advanced-search.component';
import { AdvancedFilterComponent } from './advanced-filter/advanced-filter.component';
import { EmbeddedSupersetComponent } from './embedded-superset/embedded-superset.component';
// import { log } from 'console';
import { GutestAccountNotifierComponent } from './share/gutest-account-notifier/gutest-account-notifier.component';



@NgModule({
  declarations: [
    GlobalSearchComponent,
    WildComponent,
    KeysPipe,
    RatingComponent,
    CreateReportComponent,
    InsightsComponent,
    ShareComponent,
    VideoModalComponent,
    VideoModalNewComponent,
    VocIntroComponent,
    DeletePopComponent,
    DialogContainerComponent,
    UploadFileComponent,
    ExternalFileUploadComponent,
    LoginPopupComponent,
    CopyToClipboardDialogComponent,
    CopyContentDialogComponent,
    KpiGridRowNameEditComponent,
    RemoveTopcutComponent,
    SideNavComponent,
    SubSideNavComponent,
    SubSideNavChildrenComponent,
    CommonGridViewComponent,
    VocIntroPngComponent,
    ViSummaryComponent,
    GroupSummaryComponent,
    EditFileComponent,
    LogoutConfirmationComponent,
    AdvancedSearchComponent,
    AdvancedFilterComponent,
    EmbeddedSupersetComponent,
    GutestAccountNotifierComponent
    
  ],
  entryComponents: [DialogContainerComponent, 
    CopyToClipboardDialogComponent,
    LoginPopupComponent,
    CopyContentDialogComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    ImageViewerModule,
    MatDialogModule,
    InfiniteScrollModule,
    AgGridModule.withComponents([]),
    NgxTreeSelectModule.forRoot({
      idField: 'id',
      textField: 'name',
      expandMode: ExpandMode.Selection,
    }),
    RouterModule,
    MatDialogModule,
    MainPipe
  ],
  providers: [
    KeysPipe,
    InsightApiService,
    SharedataService,
    VideoModalComponent,
    VideoModalNewComponent,
    ShareApiService,
  ],
  exports: [
    GlobalSearchComponent,
    WildComponent,
    KeysPipe,
    RatingComponent,
    ShareComponent,
    CreateReportComponent,
    InsightsComponent,
    VideoModalComponent,
    VideoModalNewComponent,
    VocIntroComponent,
    DeletePopComponent,
    UploadFileComponent,
    LoginPopupComponent,
    KpiGridRowNameEditComponent,
    RemoveTopcutComponent,
    SideNavComponent,
    SubSideNavComponent,
    SubSideNavChildrenComponent,
    CommonGridViewComponent,
    ViSummaryComponent,
    GroupSummaryComponent,
    EditFileComponent,
    LogoutConfirmationComponent,
    AdvancedFilterComponent,
    AdvancedSearchComponent,
    EmbeddedSupersetComponent,
    GutestAccountNotifierComponent
  ],
})
export class SharedModule {}